var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.isHome)?_c('img',{staticClass:"goHome",attrs:{"src":require("@/assets/all_Icon/drawable-xhdpi/home.jpg.webp")},on:{"click":_vm.goHome}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }